import React from 'react';
import Isvg from 'react-inlinesvg';

import Card from 'components/Card/Card';
import Message from 'components/Message/Message';
import When from 'components/When';
import { ICONS } from 'constants/icons';
import { integratorPropTypes } from 'constants/propTypes';
import { bem } from 'helpers/class-name';

import './IntegratorCard.scss';

const { block, element } = bem('integrator-card');

const IntegratorCard = ({
  name,
  description,
  logoImageUrl,
  supportsAppointments,
  supportsClasses,
  supportsFoodAndBev,
  onClick,
}) => {
  return (
    <Card className={block()} flush onClick={onClick}>
      <When predicate={!logoImageUrl}>
        <span className={element('logo-icon')}>{name[0]}</span>
      </When>
      <When predicate={!!logoImageUrl}>
        <img className={element('logo-image')} src={logoImageUrl} alt={`${name} logo`} />
      </When>
      <div className={element('container')}>
        <div className={element('header-container')}>
          <Message className={element('name')} message={name} />
          <span className={element('integration-type-icons')}>
            <When predicate={supportsAppointments}>
              <Isvg src={ICONS.calendarLight} />
            </When>
            <When predicate={supportsClasses}>
              <Isvg src={ICONS.dumbbellLight} />
            </When>
            <When predicate={supportsFoodAndBev}>
              <Isvg src={ICONS.foodAndBeverageLight} />
            </When>
          </span>
        </div>
        <When predicate={!!description}>
          <Message as="p" className={element('description')} message={description} />
        </When>
      </div>
    </Card>
  );
};

IntegratorCard.propTypes = integratorPropTypes;

export default IntegratorCard;
